<ng-container *transloco="let t">
  @let items = items$ | async;
  <label tuiLabel>
    @if (showLabel) {
      {{ t('Spécialité médicale') }}
    }
    <tui-textfield tuiChevron [stringify]="stringify" [tuiTextfieldCleaner]="false">
      <input
        data-testid="input"
        ngDefaultControl
        tuiComboBox
        [disabled]="disabled"
        [ngModel]="items | getFromId: value"
        [placeholder]="t('Choisissez votre spécialité médicale')"
        [tuiTextfieldCleaner]="true"
        (ngModelChange)="onValueChange($event)" />
      <tui-data-list-wrapper
        *tuiDropdown
        new
        [emptyContent]="t('Aucun résultat')"
        [itemContent]="stringify | tuiStringifyContent"
        [items]="items | tuiFilterByInput" />
    </tui-textfield>
  </label>
</ng-container>
